import React from 'react';

import VideoCard from './components/video-card/video-card';
import LearningpathContainer from './components/LearningpathContainer/learningpathContainer';
import Footer from './components/footer/footer';

import './main.scss';
import './assets/style/theme.scss';

class App extends React.Component {
    constructor(props) {
        super(props);
    }

    setContactRef = (ref) => {
        this.contactRef = ref;
    };

    setDiscoverRef = (ref) => {
        this.discoverRef = ref;
    };

    setCourseMetaRef = (ref) => {
        this.courseMetaRef = ref;
    };

    setGetAccessRef = (ref) => {
        this.getAccessRef = ref;
    };

    scrollTo = (target) => {
        switch (target) {
            case 'contactus':
                this.contactRef.scrollIntoView({
                    behavior: 'smooth',
                });
                break;
            case 'discover':
                this.discoverRef.scrollIntoView({
                    behavior: 'smooth',
                });
                break;
            case 'courseMeta':
                this.courseMetaRef.scrollIntoView({
                    behavior: 'smooth',
                });
                break;
            case 'getAccess':
                this.getAccessRef.scrollIntoView({
                    behavior: 'smooth',
                });
                break;
        }
    };

    render() {
        return (
            <div className="dls-promo-container">
                <div role="header" className="edu-header">
                    <a
                        href="https://www.3ds.com/"
                        target="_blank"
                        alt="ds-logo"
                        className="ds-logo"
                    >
                        <span className="ds-hide">Dassault Systèmes</span>
                    </a>
                    <div className="logo-right">
                        {/* <a
                            href="https://learningspace.3ds.com/CompanionManager/ui/#/"
                            target="_blank"
                            alt="3dexedu-logo"
                            className="dls-header-logo"
                            style={{ marginRight: 10 }}
                        >
                            <img
                                src="./static/img/new/3dxedu_logo.png"
                                alt="3dexedu-logo"
                            />
                        </a>
                        */}
                        <a
                            href="https://learningspace.3ds.com/CompanionManager/ui/#/"
                            target="_blank"
                            alt="3dls-logo"
                            className="dls-header-logo"
                        >
                            <img
                                src="./static/img/header_logo_edu_1920.png"
                                alt="3dls-logo"
                            />
                        </a>
                    </div>
                </div>
                <section className="carousel-container">
                    {/* <div className="carousel-header">
                        <div className="dls-logo">
                            <img src="./static/img/3DS_LOGO_3DEXP_EDU_WHITE_RGB.png" />
                            <b className="divider"></b>
                            <span className="logo-text">Learning Space</span>
                        </div>
                    </div> */}
                    <div className="carousel-main">
                        <div className="carousel-main-text">
                            <div className="carousel-main-text--main">
                                <p>
                                    {/* Dassault Systèmes’ initiatives to tackle
                                    COVID-19 challenges */}
                                    LOOKING TO INSTALL A “CULTURE CHANGE”
                                    MINDSET IN YOUR COMPANY?
                                </p>
                            </div>
                            <div className="carousel-main-text--sub">
                                <p>
                                    Dassault Systèmes’ <b>3D</b>EXPERIENCE® platform
                                    brings Lean practices that empower people to
                                    communicate, organize, and solve problems
                                    more effectively leading to end-to-end
                                    Digital Lean Transformation.
                                </p>
                                {/* <p>
                                    Discover below some inspirational modules
                                    dedicated to Digital continuity, Digital
                                    Factory and Additive Manufacturing.
                                </p> */}
                            </div>
                            {/* <span
                                role="button"
                                className="btn carousel-main-text--btn"
                                onClick={() => {
                                    this.scrollTo('contactus');
                                }}
                            >
                                Contact us
                            </span> */}
                        </div>
                    </div>
                    {/* <img
                        src="./static/1920/main_inbluepanel.jpg"
                        className="carousel-main-img2"
                    ></img> */}
                    <div className="carousel-main-video">
                        <VideoCard
                            thumb="lean_video_cover.jpg"
                            video="LEAN_INTRO_OUTRO_SRT_EN.mp4"
                        />
                    </div>
                    <div
                        className="discover-btn"
                        onClick={() => {
                            this.scrollTo('courseMeta');
                        }}
                    >
                        <img src="./static/svg/arrow.svg" />
                        <span className="discover-btn--text">Discover</span>
                    </div>
                </section>
                <LearningpathContainer
                    setCourseMetaRef={this.setCourseMetaRef}
                />
                {/* <CourseMetaContainer
                    scrollToAccess={() => {
                        this.scrollTo('getAccess');
                    }}
                    setCourseMetaRef={this.setCourseMetaRef}
                    voucherLink={voucherLink}
                /> */}
                {/* <GetAccess
                    voucherLink={voucherLink}
                    setGetAccessRef={this.setGetAccessRef}
                /> */}
                <Footer />
            </div>
        );
    }
}

export default App;
